import React, { PureComponent } from "react";
import "./styles.css";

class Snackbar extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      msg: "",
    };
  }
  showMessage = (msg) => {
    const that = this;
    this.setState(
      {
        show: true,
        msg,
      },
      () => {
        setTimeout(() => {
          that.setState({
            show: false,
            msg: "",
          });
        }, 3000);
      }
    );
  };
  render() {
    const { show, msg } = this.state;
    return (
      <div id="snackbar" className={show ? "show" : ""}>
        {msg}
      </div>
    );
  }
}

export const snackbarRef = React.createRef();

const SnackbarComponent = React.forwardRef((props, ref) => (
  <Snackbar {...props} ref={snackbarRef} />
));

export const ShowMessage = (msg) => {
  console.log("snackbarRef", snackbarRef.current);
  snackbarRef.current.showMessage(msg);
};

export default SnackbarComponent;
